import React from 'react';
import { useIntl } from 'umi';
import { CONTACT_EMAIL, CONTACT_NAME, NO_DATE } from '../../constants';
import { Card } from 'tea-component';
import '@op/assets/scss/pages/performance/components/NoData.scss';
import noData from '@/pages/home/assets/img/no-data.png';

export type NoDataType = {
  hasTitle?: boolean;
  hasDesc?: boolean;
  hasImg?: boolean;
  style?: React.CSSProperties;
  emptyTitleText?: string;
  emptyDescText?: string | React.ReactNode;
  emptyDescElement?: any;
  className?: string;
};

export default function NoData(props: NoDataType) {
  const {
    hasTitle = false,
    hasDesc = false,
    hasImg = false,
    style = {},
    emptyTitleText = NO_DATE.TITLE,
    emptyDescText = NO_DATE.SELECTION,
    emptyDescElement = null,
    className,
  } = props;

  const { formatMessage } = useIntl();
  // console.log(emptyDescElement, 'emptyDescElement');
  return (
    <div className={`dbo-no-data ${className}`} style={style}>
      {hasImg && <img src={noData} className="dbo-no-data-img" />}

      <div className="dbo-no-data-text">
        {hasTitle && (
          <div className="dbo-no-data-title">
            {formatMessage({
              id: emptyTitleText,
              defaultMessage: emptyTitleText,
            })}
          </div>
        )}
        {hasDesc && (
          <div className="dbo-no-data-desc">
            {typeof emptyDescText === 'string' && emptyDescText !== ''
              ? formatMessage({
                id: emptyDescText,
                defaultMessage: emptyDescText,
              }, {
                email: CONTACT_EMAIL,
                contact: CONTACT_NAME
              })
              : emptyDescText}
          </div>
        )}
        {emptyDescElement}
      </div>
    </div>
  );
}

export type NoDataCardProps = NoDataType & {
  contentCard?: boolean;
  children?: any;
  empty?: boolean;
  className?: string;
  height?: number;
};
export function NoDataCard(props: NoDataCardProps) {
  const {
    contentCard,
    children,
    empty,
    height,
    style = {},
    className,
    hasTitle = true,
    hasDesc = true,
    hasImg = true,
    ...nodataProps
  } = props;

  if (!empty) {
    return children;
  }

  const bodyStyle = { ...style };
  if (height) {
    bodyStyle.height = height;
  }

  if (contentCard) {
    return (
      <NoData
        {...nodataProps}
        {...{ hasTitle, hasDesc, hasImg }}
        className={className}
        style={bodyStyle}
      />
    );
  }

  return (
    <Card className={className}>
      <Card.Body className="dbo-no-data-card-body" style={bodyStyle}>
        <NoData
          {...nodataProps}
          {...{ hasTitle, hasDesc, hasImg }}
          style={{ height: '100%' }}
        />
      </Card.Body>
    </Card>
  );
}
